import styled, { css } from 'styled-components';
import { BorderRadiusMedium, ColorAdvice4, ColorNeutralDarkGrey, Spacing32 } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';

export const Wrapper = styled.div<{ alternateDesign?: boolean }>`
    display: flex;
    flex-direction: column;
    margin-bottom: ${Spacing32};

    ${breakpoint.up(sizes.xl)} {
        margin-bottom: 0;
    }

    ${({ alternateDesign }) =>
        alternateDesign &&
        css`
            margin: 0;
            margin-right: -7px;
        `}
`;

export const TopWrapper = styled.div<{ showCloseButton?: boolean; alternateDesign?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding: ${({ showCloseButton }) => (showCloseButton ? '0 16px 0 0' : '0 16px')}; //0 16px;
    margin-bottom: ${({ alternateDesign }) => (alternateDesign ? -12 : -20)}px;
`;

export const ImageWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const IconWrapper = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background-color: ${ColorAdvice4};
    padding: 4px;

    &:not(:first-child) {
        margin-left: -10px;
    }
`;

export const BottomWrapper = styled.div<{ alternateDesign?: boolean }>`
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: ${ColorAdvice4};
    border-radius: ${BorderRadiusMedium};
    padding: 20px 16px 16px;

    ${({ alternateDesign }) =>
        alternateDesign &&
        css`
            border-radius: 0 0 0 ${BorderRadiusMedium};
            height: 62px;
            padding: 12px 24px 12px 16px;
        `}
`;

export const Text = styled.div<{ alternateDesign?: boolean }>`
    color: ${ColorNeutralDarkGrey};

    ${({ alternateDesign }) =>
        alternateDesign &&
        css`
            padding-right: 10px;
        `}
`;

export const TextDesktop = styled.div<{ alternateDesign?: boolean }>`
    display: none;

    ${breakpoint.up(sizes.sm)} {
        display: block;
        color: ${ColorNeutralDarkGrey};

        ${({ alternateDesign }) =>
            alternateDesign &&
            css`
                padding-right: 10px;
            `}
    }
`;

export const TextMobile = styled.div<{ alternateDesign?: boolean }>`
    ${breakpoint.up(sizes.sm)} {
        display: none;
    }

    color: ${ColorNeutralDarkGrey};

    ${({ alternateDesign }) =>
        alternateDesign &&
        css`
            padding-right: 10px;
        `}
`;
